import React from 'react';
import RespuestaMarkdown from './RespuestaMarkdown';

// Cuando el usuario pide la foto de un artículo, el asistente pone en su respuesta la ruta
// /api/v1/image/foreverTentacionArticulos/<archivo> (endpoint público del propio backend, o la URL absoluta
// que guarda urlFoto). En el chat web esa ruta salía como texto crudo: aquí se quita del texto y se
// muestra la imagen (máx 3 por mensaje). Solo se aceptan rutas de la carpeta de artículos del sistema
// (la misma de CARPETAS_PERMITIDAS en ImagenArticuloService.js del backend).
const MAX_FOTOS = 3;
const HOST = String.raw`(?:https?:\/\/[^\s/)\]>"'\x60]+)?`;
const RUTA = String.raw`(\/api\/v1\/image\/foreverTentacionArticulos\/[A-Za-z0-9_-]{8,64}(?:\.(?:jpe?g|png|webp|gif))?)`;
// ![alt](ruta) | [texto](ruta) | ruta suelta (con o sin comillas invertidas)
const FOTO_RE = new RegExp(
  String.raw`!?\[[^\]]*\]\(\s*${HOST}${RUTA}\s*\)|\x60?${HOST}${RUTA}\x60?`,
  'gi'
);

// URL base del backend: se deriva de la URL del asistente (…/api/v1/asistente-ia) o del login.
const API_BASE_URL = (
  import.meta.env.VITE_URL_API_BASE ||
  (import.meta.env.VITE_URL_ASISTENTE_IA || import.meta.env.VITE_URL_LOGIN || '').replace(/\/api\/v1\/.*$/, '') ||
  'http://localhost:8080'
).replace(/\/+$/, '');

export function extraerFotosDeTexto(texto) {
  const original = typeof texto === 'string' ? texto : '';
  const rutas = [];
  const limpio = original
    .replace(FOTO_RE, (_m, r1, r2) => {
      const ruta = r1 || r2;
      if (ruta && !rutas.includes(ruta) && rutas.length < MAX_FOTOS) rutas.push(ruta);
      return '';
    })
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return { texto: limpio, rutas };
}

function Foto({ ruta }) {
  const [fallo, setFallo] = React.useState(false);
  if (fallo) {
    return <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>No se pudo cargar la foto del artículo.</div>;
  }
  return (
    <img
      src={`${API_BASE_URL}${ruta}`}
      alt="Foto del artículo"
      loading="lazy"
      onError={() => setFallo(true)}
      style={{ display: 'block', maxWidth: '100%', maxHeight: 280, marginTop: 8, borderRadius: 8, background: '#fff', objectFit: 'contain' }}
    />
  );
}

/** Texto del mensaje; en respuestas del asistente va en markdown y las rutas de foto se renderizan como imagen. */
export default function TextoConFotos({ content, esUsuario }) {
  if (esUsuario) return <div style={{ whiteSpace: 'pre-wrap' }}>{content}</div>;
  const { texto, rutas } = extraerFotosDeTexto(content);
  return (
    <>
      <RespuestaMarkdown texto={texto} />
      {rutas.map((ruta) => (
        <Foto key={ruta} ruta={ruta} />
      ))}
    </>
  );
}
